interface EasterEggIconProps {
  className?: string;
}

const EasterEggIcon = ({ className }: EasterEggIconProps) => (
  <svg
    viewBox="0 0 100 120"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    role="img"
  >
    {/* Egg shape */}
    <ellipse cx="50" cy="65" rx="35" ry="45" fill="#C4A7E7" />
    {/* Zigzag band */}
    <polyline
      points="15,55 25,45 35,55 45,45 55,55 65,45 75,55 85,45"
      fill="none"
      stroke="#FF69B4"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="15,70 25,60 35,70 45,60 55,70 65,60 75,70 85,60"
      fill="none"
      stroke="#87CEEB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Dots */}
    <circle cx="35" cy="82" r="4" fill="#FF69B4" />
    <circle cx="50" cy="85" r="4" fill="#87CEEB" />
    <circle cx="65" cy="82" r="4" fill="#FF69B4" />
    <circle cx="35" cy="38" r="3" fill="#98FB98" />
    <circle cx="50" cy="35" r="3" fill="#FFD700" />
    <circle cx="65" cy="38" r="3" fill="#98FB98" />
  </svg>
);

export default EasterEggIcon;
